import { TooltipModel, TooltipModelProps } from '@mail/3promo/models/tooltip';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { SafetyLocalStorage } from '@mail-core/std';
import { xray } from 'lib/xray';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { familyAddButtonTooltip, familyAddButtonTooltipConfig } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { FamilyAddButtonTooltip } from 'reactApp/ui/FamilyAddButton/FamilyAddButtonTooltip';

const TOOLTIP_CLOSED_KEY = 'family_add_button_tooltip_closed';
const TOOLTIP_SHOW_COUNT_KEY = 'family_add_button_tooltip_show_count';
const TOOLTIP_LAST_SHOWN_KEY = 'family_add_button_tooltip_last_shown';

const TOOLTIP_KEY = 'family-add-button-tooltip';

export const familyAddButtonTooltipCreator: ModelCreator = ({ models, render, stores }) => {
    const [maxShows, intervalMs] = familyAddButtonTooltipConfig;

    const state = reduxStore.getState();
    const email = UserSelectors.getEmail(state);
    const lStorage = new SafetyLocalStorage({});

    const selector = '[data-qa-id="family-add-button"]';

    return new TooltipModel(
        TOOLTIP_KEY,
        models.base,
        new TooltipModelProps(TOOLTIP_KEY, {
            store: new LocalStorageStore(TOOLTIP_KEY, stores.localStorage),
            renderer: new ReactRenderer(TOOLTIP_KEY, FamilyAddButtonTooltip as any, render.react),
            closable: true,
            hideOnOutsideClick: true,
            isModelEnabledCheck: () => true,
            ignoreTestOnRedraw: true,
            test: (resolve, reject) => {
                if (!familyAddButtonTooltip) {
                    reject();
                    return;
                }
                if (IS_PHONE_BROWSER) {
                    reject();
                    return;
                }
                const target = document.querySelector(selector) as HTMLElement;
                if (!target) {
                    reject();
                    return;
                }
                const closed = lStorage.getItem(`${email}|${TOOLTIP_CLOSED_KEY}`);
                if (closed) {
                    reject();
                    return;
                }
                const shown = parseInt(lStorage.getItem(`${email}|${TOOLTIP_SHOW_COUNT_KEY}`) || '0');
                if (shown >= maxShows) {
                    reject();
                    return;
                }
                const last = lStorage.getItem(`${email}|${TOOLTIP_LAST_SHOWN_KEY}`);
                if (last) {
                    const lastTs = parseInt(last) || 0;
                    if (Date.now() - lastTs < intervalMs) {
                        reject();
                        return;
                    }
                }
                resolve();
            },
            templateData: {
                title: 'Добавьте ещё 3 близких',
                text: 'Подпиской можно пользоваться вчетвером — место и функции общие',
                targetSelector: selector,
                placement: 'right-start',
                leftOffset: 0,
                onCrossClose: () => {
                    lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
                    xray.send('family-add-button-tooltip-cross');
                },
                onClick: () => {
                    lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
                    xray.send('family-add-button-tooltip-click');
                },
            },
            getTarget: () => {
                return document.querySelector(selector) as HTMLElement;
            },
            onShow: () => {
                const showCount = parseInt(lStorage.getItem(`${email}|${TOOLTIP_SHOW_COUNT_KEY}`) || '0');
                const lastShownStr = lStorage.getItem(`${email}|${TOOLTIP_LAST_SHOWN_KEY}`) || '0';
                const lastShown = parseInt(lastShownStr) || 0;
                const now = Date.now();
                if (now - lastShown >= 1000) {
                    lStorage.setItem(`${email}|${TOOLTIP_SHOW_COUNT_KEY}`, String(showCount + 1));
                    lStorage.setItem(`${email}|${TOOLTIP_LAST_SHOWN_KEY}`, String(now));
                }
                xray.send('family-add-button-tooltip-show');
            },
            onClose: () => {
                xray.send('family-add-button-tooltip-close');
            },
        })
    );
};
